import { ajaxCall } from "@/shared/connection/ajax-call";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";
import { makeLogger } from "@/shared/consola";
import { t } from "@/i18n";

const WALL_ENDPOINT = `/walls`;

const logger = makeLogger("google.service");

export const googleService = {
    getPlaceDetails({ placeId, sorter = "relevant", depth = 10 }) {
        logger.debug("getPlaceDetails", { placeId, sorter, depth });
        return ajaxCall
            .post(`${WALL_ENDPOINT}/google-reviews/get-reviews`, { placeId, sorter, depth })
            .then((response) => {
                const [record = {}] = response || [];
                const { items = [] } = record;
                // Map to TESTIMONIALS [@fix: items might be null]:
                logger.debug("got items", items);
                return (items || []).map((item) => ({
                    name: item.profile_name,
                    photo: item.profile_image_url,
                    content: item.review_text,
                    rate: item.rating?.value,
                    info: `${item.rating?.value || 0} ${t("love.stars", item.rating?.value || 0)} - ${item.time_ago}`,
                    source: "google",
                    type: "text",
                    hide: false,
                    confirmed: true,
                    gifs: [],
                    images: [],
                    isSelected: true,
                }));
            })
            .catch(handleErrorByMessage());
    },
    findGooglePlace({ query, nextPage }) {
        return ajaxCall
            .post(`${WALL_ENDPOINT}/google-reviews/find-place`, { query, nextPage })
            .then(({ errorMessage, nextPage, results, status }) => {
                // @next: we do not use nextPage which can "load on scrolling"
                logger.debug("findGooglePlace", { errorMessage, nextPage, status });
                return results;
            })
            .catch(handleErrorByMessage());
    },
};
